import {
  CheckOutlined,
  CloseOutlined,
  InfoCircleOutlined,
  MinusCircleOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Image,
  Input,
  message,
  Radio,
  Select,
  Space,
  Switch,
  Tag,
  Upload,
} from "antd";
import RenderIcon from "../../../utils/renderImage";
import ImgCrop from "antd-img-crop";
import { useState } from "react";

const { TextArea } = Input;
const primaryAuth = [
  { label: "PasswordLess", value: "passwordLess" },
  { label: "UserName and Password", value: "password" },
  { label: "Entra", value: "Entra" },
  { label: "SAML2", value: "SAML2" },
  { label: "OIDC", value: "OIDC" },
];
const secondaryAuth = [
  { label: "TOTP", value: "totp" },
  { label: "SMS", value: "sms" },
];

const Jwtt = () => {
  return (
    <Form.Item
      label="Security Type"
      className="mt-2 w-1/2"
      rules={[
        {
          required: true,
          message: "Please select security key",
        },
      ]}
    >
      <Select defaultValue={"jwtt"}>
        <Select.Option value="jwtt">JWTT</Select.Option>
      </Select>
    </Form.Item>
  );
};

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const normFile = (e) => {
  console.log("Upload event:", e);
  if (Array.isArray(e)) {
    return e;
  }
  return e && e.fileList;
};

const ImageUploader = ({ fileList, onChange }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  // 'value' here is the fileList provided by Form.Item
  const triggerChange = ({ fileList: newFileList }) => {
    // This tells the Form to update its internal 'appLogo' state
    onChange?.(newFileList);
  };
  console.log("value", fileList);

  return (
    <div className="flex items-start gap-6">
      <ImgCrop rotationSlider>
        <Upload
          action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
          listType="picture-card"
          fileList={fileList || []}
          onChange={triggerChange}
          onPreview={handlePreview}
        >
          {(fileList?.length || 0) < 1 && (
            <PictureOutlined className="text-4xl" />
          )}
        </Upload>
      </ImgCrop>
      {previewImage && (
        <Image
          wrapperStyle={{ display: "none" }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
      <p className="text-sm text-slate-500 mt-4 max-w-md line-clamp-3">
        Upload a clear icon for your application.
        <br /> Recommended size:
        <span className="font-medium"> 256×256px</span>.<br />
        Supported formats:
        <span className="font-medium"> .png, .jpeg</span>
      </p>
    </div>
  );
};

export function AppGeneralInfo({ fileList, setFileList, existingApp, form }) {
  const isActive = Form.useWatch("isActive", form);
  console.log("isActiveValue:", isActive);

  return (
    <>
      <section className="bg-white  border border-slate-200 rounded-xl shadow-sm overflow-hidden">
        {/* Header */}
        <div className="p-6 border-b border-slate-100">
          <h2 className="text-lg font-semibold flex items-center gap-2">
            <span className="material-icons-round text-primary text-xl">
              <InfoCircleOutlined />
            </span>
            General Information
          </h2>
        </div>

        {/* Content */}
        <div className="p-6 grid grid-cols-1 gap-6">
          {/* Application Name */}
          <Form.Item
            label={
              <span className="text-sm font-semibold text-slate-700">
                Application Name
              </span>
            }
            name="applicationName"
            rules={[
              { required: true, message: "Please enter the application name" },
            ]}
          >
            <Input
              placeholder="e.g., Enterprise CRM Portal"
              className="bg-slate-50 rounded-md"
            />
          </Form.Item>

          {/* About Application */}
          <Form.Item
            label={
              <span className="text-sm font-semibold text-slate-700 ">
                About Application
              </span>
            }
            name="aboutApplication"
          >
            <TextArea
              rows={3}
              placeholder="Describe the purpose or key features of this application for internal reference..."
              className="bg-slate-50 "
            />
          </Form.Item>

          <div className="flex items-center gap-3">
            <Form.Item label="Status" name="isActive" valuePropName="checked">
              <Switch
                className="mr-5"
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
              />
            </Form.Item>
            <Tag color={isActive ? "green" : "red"}>
              {`Application is ${isActive ? "Active" : "Inactive"}`}
            </Tag>
          </div>

          <Form.Item
            label={
              <span className="text-sm font-semibold text-slate-700">
                Application Icon
              </span>
            }
            name="appLogo"
            valuePropName="fileList"
            getValueFromEvent={normFile}
            rules={[
              {
                required: true,
                message: "Please upload your application image",
              },
            ]}
          >
            <ImageUploader />
          </Form.Item>
        </div>
      </section>
    </>
  );
}

export function PrimaryAuth() {
  return (
    <>
      <Col xs={24} md={12}>
        <Card
          bordered
          className="h-full bg-white "
          title={
            <div className="flex items-center justify-between">
              <span>Primary Factor</span>
              <Tag color="blue">Required</Tag>
            </div>
          }
        >
          <Form.Item
            name="primaryAuth"
            rules={[
              { required: true, message: "Select primary authenticator" },
            ]}
          >
            <Radio.Group className="flex flex-col gap-3">
              {primaryAuth.map((item) => (
                <div className="flex items-center justify-between gap-3 p-3 border border-slate-100 rounded-lg hover:border-primary/50 cursor-pointer transition-all bg-slate-50 /50 group">
                  <Radio key={item.value} value={item.value}>
                    <span className="font-medium flex-1">{item.label}</span>
                  </Radio>
                  <Avatar
                    className="text-[11px] text-blue-500 bg-white"
                    icon={RenderIcon(item.value)}
                  />
                </div>
              ))}
            </Radio.Group>
          </Form.Item>
        </Card>
      </Col>
    </>
  );
}

export function SecondaryAuthn({ form }) {
  // const secondaryAuthValue = Form.useWatch("secondaryAuth", form);
  // console.log("isecondaryAuth:", secondaryAuthValue);
  return (
    <>
      <Col xs={24} md={12}>
        <Card
          bordered
          className="h-full bg-white "
          title={
            <div className="flex items-center justify-between">
              <span>Secondary Factor</span>
              <Tag className="bg-gray-300 ">MFA Options</Tag>
            </div>
          }
        >
          <Space direction="vertical" className="w-full">
            <div className="flex flex-col gap-3">
              {secondaryAuth.map((item) => (
                <div
                  key={item.value}
                  className="flex items-center justify-between gap-3 p-3 border border-slate-100 rounded-lg bg-slate-50 /50 cursor-pointer hover:border-primary/50"
                >
                  <Avatar
                    className="text-[11px] text-blue-500 bg-white"
                    icon={RenderIcon(item.value)}
                  />

                  <span className="font-medium flex-1">{item.label}</span>

                  <Form.Item
                    name={["secondaryAuth", item.value]}
                    valuePropName="checked"
                    className="mb-0"
                  >
                    <Switch
                      checkedChildren={<CheckOutlined />}
                      unCheckedChildren={<CloseOutlined />}
                    />
                  </Form.Item>
                </div>
              ))}
            </div>
          </Space>
        </Card>
      </Col>
    </>
  );
}

export function EntraConfig() {
  return (
    <>
      <Col span={24}>
        <Form.Item
          label={
            <span className="flex items-center gap-1 text-sm font-semibold">
              Tenant ID
            </span>
          }
          name="tenantId"
          rules={[{ required: true, message: "Please enter the Tenant ID" }]}
        >
          <Input className="rounded-md" placeholder="Enter Tenant ID" />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item
          label={
            <span className="flex items-center gap-1 text-sm font-semibold">
              Client ID
            </span>
          }
          name="clientId"
          rules={[{ required: true, message: "Please enter the Client ID" }]}
        >
          <Input className="rounded-md" placeholder="Enter Client ID" />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item
          label={
            <span className="flex items-center gap-1 text-sm font-semibold">
              Client Secret
            </span>
          }
          name="clientSecret"
          rules={[
            { required: true, message: "Please enter the Client Secret" },
          ]}
        >
          <Input.Password
            placeholder="Enter Client Secret"
            className="rounded-md pr-2 pl-2 pt-2 pb-2 border border-slate-500"
            // optional: hide the toggle eye if you don't want reveal
            visibilityToggle={false}
          />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item
          label={
            <span className="flex items-center gap-1 text-sm font-semibold">
              Landing page URL
            </span>
          }
          name="appUrl"
          rules={[
            {
              required: true,
              message: "Please enter the Landing page URL",
            },
          ]}
        >
          <Input className="rounded-md" placeholder="https://example.com" />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Jwtt />
      </Col>
    </>
  );
}

export function SamlConfig() {
  return (
    <>
      {/* Application Service URL */}
      <Col span={24}>
        <Form.Item
          label={
            <span className="flex items-center gap-1 text-sm font-semibold">
              Application URL
            </span>
          }
          name="appUrl"
          rules={[
            { required: true, message: "Please enter the application URL" },
            { type: "url", message: "Enter a valid HTTPS URL" },
          ]}
        >
          <Input className="rounded-md" placeholder="https://app.enterprise.com" />
        </Form.Item>
      </Col>

      {/* Login URL */}
      <Col span={24}>
        <Form.Item
          label={
            <span className="flex items-center gap-1 text-sm font-semibold">
              Login URL
            </span>
          }
          name="loginUrl"
          rules={[
            { required: true, message: "Please enter the login URL" },
            { type: "url", message: "Enter a valid HTTPS URL" },
          ]}
        >
          <Input className="rounded-md" placeholder="https://app.enterprise.com/saml/login" />
        </Form.Item>
      </Col>

      {/* Logout URL */}
      <Col span={24}>
        <Form.Item
          label={
            <span className="flex items-center gap-1 text-sm font-semibold">
              Single Logout URL
            </span>
          }
          name="logoutUrl"
          rules={[
            { required: true, message: "Please enter the logOut URL" },
            { type: "url", message: "Enter a valid HTTPS URL" },
          ]}
        >
          <Input className="rounded-md" placeholder="https://app.enterprise.com/saml/logout" />
        </Form.Item>
      </Col>

      {/* Metadata URL */}
      <Col span={24}>
        <Form.Item
          label={
            <span className="flex items-center gap-1 text-sm font-semibold">
              Metadata URL
            </span>
          }
          name="metadataUrl"
          rules={[
            { required: true, message: "Please enter the metadata URL" },
            { type: "url", message: "Enter a valid HTTPS URL" },
          ]}
        >
          <Input className="rounded-md" placeholder="https://app.enterprise.com/saml/metadata.xml" />
        </Form.Item>
      </Col>
    </>
  );
}

export function OidcConfig({
  currentUri,
  setCurrentUri,
  form,
  redirectUris,
  setRedirectUris
}) {
    const handleAddUri = () => {
    const trimmedUri = currentUri.trim();

    if (!trimmedUri) return; // ignore empty
    if (redirectUris.includes(trimmedUri)) {
      message.warning("This redirect URIS is already added.");
      return;
    }

    const newUris = [...redirectUris, trimmedUri];
    setRedirectUris(newUris);
    form.setFieldsValue({ redirectUris: newUris }); // update form value

    setCurrentUri("");
  };

    const handleRemoveUri = (uri) => {
    const newUris = redirectUris.filter((item) => item !== uri);
    setRedirectUris(newUris);
    form.setFieldsValue({ redirectUris: newUris });
  };
  return (
    <>
      <Col span={24}>
        <Form.Item
          label={
            <span className="flex items-center gap-1 text-sm font-semibold">
              Client ID
            </span>
          }
          name="clientId"
          rules={[{ required: true, message: "Please enter the Client ID" }]}
        >
          <Input className="rounded-md" placeholder="Enter Client ID" />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item
          label={
            <span className="flex items-center gap-1 text-sm font-semibold">
              Client Secret
            </span>
          }
          name="clientSecret"
          rules={[
            { required: true, message: "Please enter the Client Secret" },
          ]}
        >
          <Input.Password
            placeholder="Enter Client Secret"
            className="rounded-md pr-2 pl-2 pt-2 pb-2 border border-slate-500"
            // optional: hide the toggle eye if you don't want reveal
            visibilityToggle={false}
          />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item
          label={
            <span className="flex items-center gap-1 text-sm font-semibold">
              Authentication URL
            </span>
          }
          name="authUrl"
          rules={[
            {
              required: true,
              message: "Please enter the Authentication URL",
            },
          ]}
        >
          <Input
            className="rounded-md"
            placeholder="https://auth.example.com"
          />
        </Form.Item>
      </Col>

      {/* Redirect URIs */}
      <Col span={24}>
        <Form.Item
          label={
            <span className="flex items-center gap-1 text-sm font-semibold">
              Redirect URIS
            </span>
          }
          name="redirectUris"
          rules={[
            { required: true, message: "Please enter the redirect URIS" },
          ]}
        >
          <div className="flex gap-2 items-center">
            <Input
              value={currentUri}
              onChange={(e) => setCurrentUri(e.target.value)}
              placeholder="https://example.com/callback"
              className="rounded-md"
            />
            <Button type="dashed" onClick={handleAddUri}>
              Add
            </Button>
          </div>

          {/* List of added URIs */}
          <div className="mt-2 space-y-1">
            {redirectUris?.map((uri) => (
              <div
                key={uri}
                className="flex items-center justify-between bg-gray-100 px-3 py-1 rounded"
              >
                <span>{uri}</span>
                <MinusCircleOutlined
                  onClick={() => handleRemoveUri(uri)}
                  className="text-red-500 cursor-pointer"
                />
              </div>
            ))}
          </div>
        </Form.Item>
      </Col>
      <Col span={24}>
        <Jwtt />
      </Col>
      {/* Scopes */}
      <Col span={24}>
        <Form.Item
          name="scopes"
          label={
            <span className="flex items-center gap-1 text-sm font-semibold">
              Scopes
            </span>
          }
          rules={[{ required: true, message: "Select at least one scope" }]}
        >
          <Checkbox.Group className="flex flex-col gap-2">
            <Checkbox value="openid">Openid</Checkbox>
            <Checkbox value="profile">Profile</Checkbox>
            <Checkbox value="email">Email</Checkbox>
          </Checkbox.Group>
        </Form.Item>
      </Col>
    </>
  );
}
